import React, { ReactElement } from 'react'
import PurpleEllipsis from 'images/barry/purple-ellipsis.svg'
import BarryButtonIcon from 'images/barry/barry-button-icon.svg'
import { IconButton } from 'theme-ui'
import BarryPopUp, { BarryPopUpMessagAction } from 'components/Barry/BarryComponents/BarryPopUp'
import { iconWobble } from 'components/Barry/utils/IconWobble'
import useBarryViewState from 'components/Barry/hooks/useBarryController '

const toggleButtonSize = '4.8rem'

export default function BarryIcon({
  hasPopupMessage,
  barryPopupMessage,
  handleToggle,
  onPopupInteraction,
}: {
  hasPopupMessage: boolean
  barryPopupMessage: React.ReactNode
  handleToggle: () => void
  onPopupInteraction: (action: BarryPopUpMessagAction) => void
}): ReactElement {
  const { isBarryDialogOpen, isBarryIconVisible } = useBarryViewState()

  return (
    <>
      <IconButton
        sx={{
          zIndex: 'zIndex625',
          opacity: 1,
          margin: 0,
          padding: 0,
          width: toggleButtonSize,
          height: toggleButtonSize,
          borderRadius: '50%',
          position: 'fixed',
          bottom: ['1.6rem', '2.4rem'],
          right: ['1.6rem', '2.4rem'],
          cursor: 'pointer',
          animation: hasPopupMessage ? `${iconWobble} 4.5s ease 0s infinite` : 'none',
          animationFillMode: 'forwards',
          pointerEvents: 'auto',
          '@media screen and (max-width: 1620px)': {
            opacity: isBarryIconVisible ? 1 : 0,
            pointerEvents: isBarryIconVisible ? 'auto' : 'none',
          },
        }}
        onClick={handleToggle}
        id="barry-toggle"
        data-testid="barry-toggle"
        aria-label="barry toggle"
      >
        {isBarryDialogOpen ? <PurpleEllipsis /> : <BarryButtonIcon />}
      </IconButton>
      {hasPopupMessage && (
        <BarryPopUp barryMessage={barryPopupMessage} handlePopupInteraction={onPopupInteraction} />
      )}
    </>
  )
}
